import React from 'react';
import { useTranslation } from 'react-i18next';
import { DurationTicker } from 'components/DurationTicker';
import { useSelector } from 'react-redux';
import { getMachineOperationalStatusSinceIndicator } from 'lib/selectors/getMachineOperationalStatusSinceIndicator';
import { CustomClockRegular } from 'components/CustomClockRegular';
import { getIsErpDriven } from 'lib/selectors/getIsErpDriven';
import { Container, Body, Subtitle, Title, Header, Footer } from './styled';
import ShiftIndicator from './ShiftIndicator';
import AssignJob from './AssignJob';
import { DURATION_FORMAT, DURATION_OPTIONS } from '../Tabs/constants';

const UnknownJob = () => {
  const { t } = useTranslation();

  const since = useSelector(getMachineOperationalStatusSinceIndicator);
  const isErpDriven = useSelector(getIsErpDriven);

  return (
    <Container className="unknown-job">
      <Header style={{ height: '5.5rem', paddingTop: '2.75rem' }}>
        <ShiftIndicator />
      </Header>
      <Body>
        <Title>{t('Unknown Job')}</Title>
        <Subtitle>
          <CustomClockRegular
            autoPlay
            autoPlayMinuteInterval={100}
            autoPlayMinuteStep={1}
          />
          {since && (
            <DurationTicker
              startDate={since}
              format={DURATION_FORMAT}
              formatOptions={{ ...DURATION_OPTIONS, trim: 'small' }}
            />
          )}
        </Subtitle>
      </Body>
      <Footer>{!isErpDriven && <AssignJob />}</Footer>
    </Container>
  );
};

export default UnknownJob;
